<template>
  <div class="message-box">
    <!-- <svg class="svg-gray"
            width="30px"
            height="30px"
            viewBox="0 0 30 30"
            version="1.1">
        <path d="M23.7464987,8 L7.25350132,8 C6.56235651,8 6,8.56104486 6,9.25057765 L6,21.7494224 C6,22.4390266 6.56235651,23 7.25350132,23 L23.7464987,23 C24.4376435,23 25,22.4390266 25,21.7494224 L25,9.25057765 C25,8.56104486 24.4377151,8 23.7464987,8 Z M7.25350132,9.0719237 L23.7464987,9.0719237 C23.8435555,9.0719237 23.9255703,9.15374721 23.9255703,9.25057765 L23.9255703,17.5739937 L21.0526885,13.8955803 C20.8395217,13.6226686 20.5275073,13.459093 20.1965829,13.4469445 C19.8657302,13.4345817 19.5424701,13.5749322 19.309677,13.8315508 L15.5821939,17.9414491 C15.4924432,18.040352 15.2933155,18.0676503 15.1800706,17.9966175 L12.1152241,16.0710138 C11.5900429,15.7409327 10.8213959,15.7749484 10.3275163,16.1499788 L7.0744297,18.6199768 L7.0744297,9.25057765 C7.0744297,9.15374721 7.1564445,9.0719237 7.25350132,9.0719237 Z M23.7464987,21.9280763 L7.25350132,21.9280763 C7.1564445,21.9280763 7.0744297,21.8462528 7.0744297,21.7494224 L7.0744297,19.9670276 L10.9782626,17.0029442 C11.1138556,16.9000395 11.3987227,16.8874623 11.542768,16.9780041 L14.6076145,18.9036079 C15.1615905,19.2516972 15.9396208,19.1449336 16.3789193,18.6606385 L20.1064025,14.5507401 C20.1287506,14.5260859 20.1447238,14.5185824 20.1571156,14.5180822 C20.1664989,14.5184395 20.1846926,14.5281582 20.2051784,14.5543846 L23.9255703,19.3178706 L23.9255703,21.7493509 C23.9255703,21.8462528 23.8435555,21.9280763 23.7464987,21.9280763 Z M13.9395341,15.2567091 C12.8902461,15.2567091 12.0366475,14.4050299 12.0366475,13.3582607 C12.0366475,12.3114915 12.8902461,11.4598124 13.9395341,11.4598124 C14.9887505,11.4598124 15.8424207,12.31142 15.8424207,13.3582607 C15.8424207,14.4051014 14.9888222,15.2567091 13.9395341,15.2567091 Z M13.9395341,12.5316646 C13.4826866,12.5316646 13.1110772,12.9024788 13.1110772,13.3581893 C13.1110772,13.8139712 13.4826866,14.1847139 13.9395341,14.1847139 C14.3963816,14.1847139 14.767991,13.8139712 14.767991,13.3581893 C14.767991,12.9024073 14.3963816,12.5316646 13.9395341,12.5316646 Z"
                id="path-1">
        </path>
    </svg> -->
    <app-dropzone
        ref="smsDropzone"
        @fileAdd="fileAdded($event)"
        @remove="fileRemoved($event)"
        :optionsProp="dropzoneOptions"
        class="upload-photo"/>
    <input v-if="is_input"
        type="text"
        @drop="onDrop"
        v-on:keyup.enter="sendSms(user_info)"
        placeholder="Type your message here"
        v-model="message">
    <svg @click="() => sendSms(user_info)"
        class="svg-gray"        
        width="30px"
        height="30px"
        viewBox="0 0 30 30"
        version="1.1">
        <path d="M23.2911397,6.01642237 C23.2857842,6.01772297 23.2803904,6.01879406 23.2750349,6.02024768 L5.42258073,10.8890333 C4.97390338,11.0114052 4.85045878,11.5903285 5.20870444,11.8854899 L10.7649741,16.4629395 L9.7419561,19.5319139 C9.59284327,19.9793229 10.0196778,20.4070315 10.4677813,20.2577294 L13.5367971,19.2347251 L18.1143082,24.7909201 C18.4106977,25.1506145 18.988596,25.0248381 19.1107782,24.5770467 L23.9795911,6.72479437 C23.9811212,6.71917116 23.9822688,6.71347144 23.9836077,6.70780997 C24.0843297,6.28721648 23.7045854,5.91661987 23.2911397,6.01642237 Z M6.79389844,11.7045524 L20.9390361,7.84683605 L11.4372442,15.5299066 L6.79389844,11.7045524 Z M13.3884111,18.0744686 L11.1935683,18.8060985 L11.925208,16.6112852 L19.5704726,10.4292686 L13.3884111,18.0744686 Z M18.2951716,23.2056709 L14.4697277,18.5623876 L22.1529781,9.06068531 L18.2951716,23.2056709 Z"
                id="path-1">
        </path>
    </svg>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  components: {
    AppDropzone: () => import("@/components/Dropzone"),
  },
  props: ['user_info'],
  data: () => ({
    dropzoneOptions: {
      dictDefaultMessage: `<svg class="svg-gray"  @click="click" width="30px" height="30px" viewBox="0 0 30 30" version="1.1">
                            <path d="M23.7464987,8 L7.25350132,8 C6.56235651,8 6,8.56104486 6,9.25057765 L6,21.7494224 C6,22.4390266 6.56235651,23 7.25350132,23 L23.7464987,23 C24.4376435,23 25,22.4390266 25,21.7494224 L25,9.25057765 C25,8.56104486 24.4377151,8 23.7464987,8 Z M7.25350132,9.0719237 L23.7464987,9.0719237 C23.8435555,9.0719237 23.9255703,9.15374721 23.9255703,9.25057765 L23.9255703,17.5739937 L21.0526885,13.8955803 C20.8395217,13.6226686 20.5275073,13.459093 20.1965829,13.4469445 C19.8657302,13.4345817 19.5424701,13.5749322 19.309677,13.8315508 L15.5821939,17.9414491 C15.4924432,18.040352 15.2933155,18.0676503 15.1800706,17.9966175 L12.1152241,16.0710138 C11.5900429,15.7409327 10.8213959,15.7749484 10.3275163,16.1499788 L7.0744297,18.6199768 L7.0744297,9.25057765 C7.0744297,9.15374721 7.1564445,9.0719237 7.25350132,9.0719237 Z M23.7464987,21.9280763 L7.25350132,21.9280763 C7.1564445,21.9280763 7.0744297,21.8462528 7.0744297,21.7494224 L7.0744297,19.9670276 L10.9782626,17.0029442 C11.1138556,16.9000395 11.3987227,16.8874623 11.542768,16.9780041 L14.6076145,18.9036079 C15.1615905,19.2516972 15.9396208,19.1449336 16.3789193,18.6606385 L20.1064025,14.5507401 C20.1287506,14.5260859 20.1447238,14.5185824 20.1571156,14.5180822 C20.1664989,14.5184395 20.1846926,14.5281582 20.2051784,14.5543846 L23.9255703,19.3178706 L23.9255703,21.7493509 C23.9255703,21.8462528 23.8435555,21.9280763 23.7464987,21.9280763 Z M13.9395341,15.2567091 C12.8902461,15.2567091 12.0366475,14.4050299 12.0366475,13.3582607 C12.0366475,12.3114915 12.8902461,11.4598124 13.9395341,11.4598124 C14.9887505,11.4598124 15.8424207,12.31142 15.8424207,13.3582607 C15.8424207,14.4051014 14.9888222,15.2567091 13.9395341,15.2567091 Z M13.9395341,12.5316646 C13.4826866,12.5316646 13.1110772,12.9024788 13.1110772,13.3581893 C13.1110772,13.8139712 13.4826866,14.1847139 13.9395341,14.1847139 C14.3963816,14.1847139 14.767991,13.8139712 14.767991,13.3581893 C14.767991,12.9024073 14.3963816,12.5316646 13.9395341,12.5316646 Z"
                              id="path-1">
                            </path>
                          </svg>`,
    },
    is_input: true,
    message: '',
  }),
  methods: {
    ...mapActions({
      addSms: 'smses/postSms',
    }),
    async sendSms(user_info) {
      if(!this.message) { return }
      const { items: aniList } = await this.$store.dispatch("GetAllDids",{ did_type : 'ANI' });
      let ani = aniList[0].using.did_number;

      const newSms = {
          recipient_uuid: user_info.recipient_uuid,
          text: this.message,
          company_uuid: user_info.company_uuid,
          ani : ani
        }

      this.addSms(newSms)
        .then((res) => {
          this.isNewMessage = false;
          this.newRecipientId = null;
          //this.GetList(user_info);
          this.message = "";
          this.$emit('changeInfiniteId', 0);
        })
        .catch(err => {
          this.$error(err);
        });
    },
    onDrop: function(e) {
      e.stopPropagation();
      e.preventDefault();
      this.is_input =false;

      var files = e.dataTransfer.files;
      this.createFile(files[0]);
      var path = (window.URL || window.webkitURL).createObjectURL(files[0]);
      console.log("files[0]--> ", path)

      // var file = { size: 1024, name: "Icon", type: "image/png" };
      // var url = "https://myvizo.com/img/logo_sm.png";
      // this.$refs.smsDropzone.manuallyAddFile(file, files[0]);

      var mockFile = { size: 1024, name: "Userlogo", type: "image/png" };
      this.$refs.smsDropzone.$el.dropzone.emit("addedfile", mockFile);
      console.log('mockFile', mockFile)
      this.$refs.smsDropzone.$el.dropzone.emit(
        "thumbnail",
        mockFile,
        path
      );
      this.$refs.smsDropzone.$el.dropzone.emit("complete", mockFile);

      // var file = e.dataTransfer.files[0];
      // var mockFile = { name: file.name, size: file.file_size };
      // this.$refs.smsDropzone.manuallyAddFile(mockFile);
    },
  }
}
</script>

<style lang="scss">
.message-box {
  width: 100%;
  display: flex;
  .svg-gray {
        cursor: pointer;
        margin-left: 15px;
        fill: #55616e;
    }
    .svg-gray:first-child {
        margin-left: 0;
    }
    .upload-photo,
    #dropzone {
        // margin-left: 15px;
        border: none;
        width: 30px;
        //min-height: 60px !important;
        height: 30px;
        color: #55616e;
        font-family: "Helvetica Neue";
        font-size: 14px;
        line-height: 25px;
        padding: 0;
        .dz-image {
        //padding: 5px;
        img {
            height: 30px;
            width: 30px;
            border-radius: 50px;
        }
        }
        .dz-message {
        margin:0;
        }
    }
    .vue-dropzone {
        min-height: 30px;
        margin-right: 0;
    }
    input {
        margin-left: 15px;
        border: none;
        width: 100%;
        height: 100%;
        color: #55616e;
        font-family: "Helvetica Neue";
        font-size: 14px;
        line-height: 25px;
    }
}
</style>